wbApp.factory('notRegisteredUserSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {

        var NotRegistredUser = $resource('/restapi/not-registered-users/:id', {}, {
            'getById': { method: 'GET', url: '/restapi/not-registered-users/:id' },
            'getAll': { method: 'GET', isArray: true, url: 'restapi/not-registered-users' },
            'insert': { method: 'POST', url: '/restapi/not-registered-users' },
            'update': { method: 'PUT', url: '/restapi/not-registered-users/:id' },
            'delete': { method: 'DELETE', url: '/restapi/not-registered-users/:id' },
        });

        var notRegisteredUsers;

        function createNew()
        {
            var notRegisteredUsers = {
                isNew: true,
                students: [{
                }]
            };

            return notRegisteredUsers;
        }

        function insert(model) {
            return repositorySvc.customPost(
                'insert',
                NotRegistredUser,
                model);
        }

        function remove(userId) {
            notRegisteredUsers = null;
            return repositorySvc.customDelete(
                'delete',
                NotRegistredUser,
                { id: userId });
        }

        function update(model) {
            notRegisteredUsers = null;
            return repositorySvc.customPutWithParams(
                'update',
                NotRegistredUser,
                { id: model.id },
                model);
        }

        function getById(userId) {
            return repositorySvc.customGet('getById', NotRegistredUser, { id: userId });
        }

        function getAll(refresh) {
            if (!notRegisteredUsers || refresh) {
                notRegisteredUsers = repositorySvc.customGet('getAll', NotRegistredUser, {});
            }
            return notRegisteredUsers;
        }

        return {
            createNew: createNew,
            getById: getById,
            getAll: getAll,
            insert: insert,
            remove: remove,
            update: update,
        }
    }
]);